import { render, staticRenderFns } from "./EmployeesPage.vue?vue&type=template&id=0f04699e&scoped=true"
import script from "./EmployeesPage.vue?vue&type=script&lang=js"
export * from "./EmployeesPage.vue?vue&type=script&lang=js"
import style0 from "./EmployeesPage.vue?vue&type=style&index=0&id=0f04699e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04699e",
  null
  
)

export default component.exports